import { UnprotectedRouteResponsiveCard } from "@eisox/design-system";

import { SignInForm, type SignInFormProps } from "./sign-in-form.component";

interface SignInPageProps extends SignInFormProps {
  version: string;
  cardClassName?: string;
}

const SignInPage: React.FC<SignInPageProps> = ({ version, cardClassName, ...formProps }) => (
  <UnprotectedRouteResponsiveCard className={cardClassName} version={version}>
    <SignInForm {...formProps} />
  </UnprotectedRouteResponsiveCard>
);

export { SignInPage };
export type { SignInPageProps };
